// Lib
import { ThemeFile } from 'lib/context/ThemeContext';

export const ImageCarouselTheme: ThemeFile = {
  aw: {
    classes: {},
  },
  rba: {
    classes: {
      headlineClass: 'text-theme-text text-sm-m md:text-l font-medium mb-xxs pt-5',
      subHeadlineClass: ' text-theme-text text-sm-s md:text-s font-extra-light mb-s',
      buttonClass: {
        wrapper: 'justify-center mt-m',
        cta1Classes: 'font-bold',
      },
      slideCaption: '',
      carouselWrapper: 'carousel-slider col-span-full lg:col-span-8 lg:col-start-3',
      sliderContainer: '[&_.section-grid]:px-1 [&_.promo-generic-wrapper]:px-1',
      captionContainer:
        'mt-xxs md:mt-xxxs border-primary border-l-3 pl-xxs text-left mb-s text-sm-xxs md:text-body font-regular [&_strong]:text-black ',
    },
  },
};
